// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___3AXYL","item-wrap":"styles__item-wrap___2BLwp","item-text":"styles__item-text___gEXtp","icon":"styles__icon___3cisb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Realtime/MenuData/styles.scss
// module id = 7693
// module chunks = 0